import React, { useState } from 'react';
import MpesaPayment from '../Mpesa/MpesaPayment';
import { useCart } from '../Cart/CartContext';
import EliteSeriesBots from './EliteSeriesBots';
import HuslerSeriesBots from './HuslerSeriesBots';

function Bots() {
  const [showPayment, setShowPayment] = useState(false);
  const { buyNow } = useCart(); // You need this if passing `buyNow`

  // Pass this to child component
  const handleBuyNow = (bot) => {
    buyNow(bot);
    setShowPayment(true);
  };

  return (
    <div id="bots">
      <h1 className='custom-h1'>Available Bots</h1>
      <hr className="border-t border-gray-300 my-4" />
      <EliteSeriesBots onBuyNow={handleBuyNow} />
      <HuslerSeriesBots onBuyNow={handleBuyNow} />
      <MpesaPayment show={showPayment} onClose={() => setShowPayment(false)} />
    </div>
  );
}

export default Bots;
